const getEnvironment = (domain: string) => {
    if (domain.includes('local') || domain.includes('dev')) {
        return 'dev'
    } else if (domain.includes('stg')) {
        return 'stg'
    }
    return '';
}

export default getEnvironment;